const ReturnBoxSvg = ({
  width = 16,
  height = 16,
  className = '',
  viewBox = '0 0 24 24',
}: {
  width?: number;
  height?: number;
  className?: string;
  viewBox?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <polyline points="9 14 4 9 9 4" />
      <path d="M20 20v-7a4 4 0 0 0-4-4H4" />
    </svg>
  );
};

export default ReturnBoxSvg;
